import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-password-strength-tooltip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './password-strength-tooltip.component.html',
  styleUrl: './password-strength-tooltip.component.css'
})
export class PasswordStrengthTooltipComponent {
  @Input() password: string = '';
  @Input() show: boolean = false;

  get passwordStrength(): string {
    if (!this.password) return 'Very weak';
    
    const hasMinLength = this.password.length >= 8;
    const hasUppercase = /[A-Z]/.test(this.password);
    const hasLowercase = /[a-z]/.test(this.password);
    const hasNumber = /\d/.test(this.password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(this.password);
    
    const strengthCount = [hasMinLength, hasUppercase, hasLowercase, hasNumber, hasSpecialChar].filter(Boolean).length;
    
    if (strengthCount <= 1) return 'Very weak';
    if (strengthCount <= 2) return 'Weak';
    if (strengthCount <= 3) return 'Medium';
    if (strengthCount <= 4) return 'Strong';
    return 'Very strong';
  }

  get strengthLevel(): number {
    const strength = this.passwordStrength;
    switch (strength) {
      case 'Very weak': return 1;
      case 'Weak': return 2;
      case 'Medium': return 3;
      case 'Strong': return 4;
      case 'Very strong': return 4;
      default: return 1;
    }
  }

  get requirements(): Array<{text: string, met: boolean}> {
    return [
      { text: '8+ characters', met: this.password.length >= 8 },
      { text: 'At least 1 uppercase character', met: /[A-Z]/.test(this.password) },
      { text: 'At least 1 special character', met: /[!@#$%^&*(),.?":{}|<>]/.test(this.password) },
      { text: 'At least 1 numeric character', met: /\d/.test(this.password) }
    ];
  }
}
